// カートに商品があれば「カートへ進む」を表示、商品タイトルを非表示
const stickyCartLink = document.getElementById('sticky-cart-link');
const stickyTitle = document.querySelector('.sticky-atc-title');

fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    if (cart.item_count > 0) {
      if (stickyCartLink) stickyCartLink.style.display = 'flex';
      if (stickyTitle) stickyTitle.style.display = 'none';
    }
  });


const stickyBar = document.getElementById('sticky-atc');
const originalBtn = document.querySelector('form[action="/cart/add"] [type="submit"]');

// 初期は非表示
stickyBar.style.display = 'none';

const observer = new IntersectionObserver(([entry]) => {
  // カートボタンが画面外に出たら表示、画面内に戻ったら非表示
  // ただしカートボタンより上（ページ上部）にいる場合は非表示のまま
  if (!entry.isIntersecting && entry.boundingClientRect.top > 0) {
    // カートボタンがまだ下にある（スクロール前）→ 非表示
    stickyBar.style.display = 'none';
  } else if (!entry.isIntersecting && entry.boundingClientRect.top <= 0) {
    // カートボタンを過ぎた → 表示
    stickyBar.style.display = 'flex';
    stickyBtn.style.background = '';
    stickyBtn.style.color = '';
  } else {
    // カートボタンが見えている → 非表示
    stickyBar.style.display = 'none';
  }
});
if (originalBtn) observer.observe(originalBtn);


// スティッキーボタンのクリック処理
const stickyBtn = document.getElementById('sticky-atc-btn');
if (stickyBtn) {
  stickyBtn.addEventListener('click', function() {

    // 押下フィードバック（一瞬白く）
    stickyBtn.style.transition = 'background 0.15s ease, color 0.15s ease';
    stickyBtn.style.background = '#ffffff';
    stickyBtn.style.color = '#000000';

    setTimeout(() => {
      if (originalBtn) {
        originalBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 150);

  });
}

// Chromeスマホのブラウザバー対応
if (window.visualViewport) {
  const adjustStickyBar = () => {
    const bottomOffset = window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop;
    stickyBar.style.bottom = Math.max(0, bottomOffset) + 'px';
  };
  window.visualViewport.addEventListener('resize', adjustStickyBar);
  window.visualViewport.addEventListener('scroll', adjustStickyBar);
  adjustStickyBar();
}